import axios from "axios";
import { BASE_URL } from "../api/api";

const api = axios.create({
  baseURL: `${BASE_URL}`,
});

api.interceptors.request.use((config) => {
  const session = sessionStorage.getItem("studentSession");
  if (session) {
    const { token } = JSON.parse(session);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
